import React, { useRef } from "react";
import PropTypes from "prop-types";

const Dropdown = ({
  title,
  placeholder = "Select an option",
  dropdownContents = [],
  icon,
  width = "400px",
  onSelect,
  defaultValue = null,
  disabled = false,
}) => {
  const id = useRef(
    `dropdown-${Math.random().toString(36).substr(2, 9)}`,
  ).current;

  const handleChange = (event) => {
    const selectedIndex = event.target.selectedIndex - 1;
    if (onSelect && selectedIndex >= 0) {
      onSelect(dropdownContents[selectedIndex]);
    }
  };

  return (
    <div
      style={{
        maxWidth: width,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 6,
      }}
    >
      <label className="dd-section-label" htmlFor={id}>
        {title}
        {icon && (
          <img
            src={icon}
            alt=""
            style={{ width: 16, marginLeft: 4, display: "inline" }}
          />
        )}
      </label>
      <div className="dd-select-wrapper">
        <select
          id={id}
          className="dd-select"
          defaultValue={
            defaultValue !== null ? dropdownContents[defaultValue] : ""
          }
          onChange={handleChange}
          disabled={disabled}
        >
          <option value="" disabled hidden>
            {placeholder}
          </option>
          {dropdownContents.map((item, index) => (
            <option
              key={index}
              value={typeof item === "string" ? item : item.label}
            >
              {typeof item === "string" ? item : item.label}
            </option>
          ))}
        </select>
        {/* <div className="dd-select-arrow">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M6 9l6 6 6-6" />
          </svg>
        </div> */}
      </div>
    </div>
  );
};

Dropdown.propTypes = {
  title: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  dropdownContents: PropTypes.array,
  icon: PropTypes.string,
  width: PropTypes.string,
  onSelect: PropTypes.func,
  defaultValue: PropTypes.number,
  disabled: PropTypes.bool,
};

export default Dropdown;
